module.exports = __webpack_public_path__ + "static/media/landing-orgAspect.0c27d127.mp4";